import { GlobalItems } from '@/accessControl/GlobalItems.atom';
import { LockingSection } from '@/accessControl/LockingSection.molecule';
import type { VersionState } from '@/core/hooks/useVersionState.hook';

type LockAnalysisProps = {
  versionState: VersionState;
  disabled?: boolean;
  showVersioningSection?: boolean;
  checkboxId: string;
  checkboxLabel: string;
  isChecked: boolean;
  onCheckChange: (checked: boolean) => void;
  hasLockingFailedPreviouslyDueToGlobalItems: boolean;
};

export const LockAnalysis = ({
  hasLockingFailedPreviouslyDueToGlobalItems,
  ...lockingSectionProps
}: LockAnalysisProps) => (
  <>
    <LockingSection {...lockingSectionProps} />
    <div className="tw:mt-sq-5 tw:mb-sq-10 tw:flex tw:w-full tw:flex-row tw:justify-center">
      <GlobalItems hasLockingFailedPreviouslyDueToGlobalItems={hasLockingFailedPreviouslyDueToGlobalItems} />
    </div>
  </>
);
